module.exports = __webpack_public_path__ + "media/icons/info-blue-83b2c3de.png";